import { Component } from 'react';
import BaseView from '../base/base-view';
import { IViewService } from '../interface/view-service.interface';
import { Disposer } from '../interface/view.interface';
import { disposeOnUnmount } from 'mobx-react';

/**
 * React相关UI，为了避免多继承，这里和React.Component是组合关系
 */
export default class ReactView<P={}> extends BaseView<P> {
    /**
     * 一般是真实渲染的View。
     * @protected
     */
    protected realView?: Component<P>;

    public constructor(realView?: Component<P>) {
        super();
        this.realView = realView;
    }

    public bindViewService(service: IViewService<P>) {
        super.bindViewService(service);
        this.applyInitState();
    }

    /**
     * react触发刷新
     * @param callBack
     */
    public forceRender(callBack?: () => void): void {
        this.realView?.forceUpdate(callBack);
    }

    /**
     * 获取父组件传递过来的props数据
     */
    public getProps(): P | undefined {
        return this.realView?.props;
    }

    /**
     * 属性组件，这里调用的是setState
     * @param callBack
     */
    public renderView(callBack?: () => void) {
        const model = this.viewService?.getModel();
        const state = model?.modelToObject();
        if (state) {
            this.realView?.setState({ ...state }, callBack);
        }
    }

    public disposeOnUnmount<TF extends Disposer | Disposer[]>(fn: TF): TF {
        if (!this.realView) return fn;
        return disposeOnUnmount(this.realView, fn);
    }

    /**
     * 初始赋值react组件的state。避免组件preState状态不对
     */
    private applyInitState(): void {
        const model = this.viewService?.getModel();
        const state = model?.modelToObject();
        if (state) {
            // @ts-ignore
            this.realView.state = { ...state };
        }
    }
}
